const env = {
  ...process.env,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...((window as any).env || {}),
  BASE_URL: `${window.location.protocol}://${window.location.host}:${window.location.port}`
};

export default env;
